import React, { useState } from 'react';
import Button from '../../components/ui/Button.js';
import Input from '../../components/ui/Input.js';
import Card from '../../components/ui/Card.js';
import './LoginPage.css';
import { loginPost } from '../../api/login/login.api.js';

const LoginPage = ({ onLogin }) => {
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleInputChange = (field) => (e) => {
    setFormData(prev => ({
      ...prev,
      [field]: e.target.value
    }));
    setError(''); // Clear error when user types
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.username || !formData.password) {
      setError('Please fill in all fields');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      const response = await loginPost(formData.username, formData.password);
      
      if (response.error) {
        setError(`Login failed: ${response.data?.error || response.data || 'Unknown error'}`);
      } else {
        // Store token and user data
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.user));
        
        // Call onLogin with user data
        onLogin({ user: response.data.user });
      }
      
    } catch (error) {
      setError('Login failed. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-page__container">
        <div className="login-page__header">
          <div className="login-page__logo">
            <img src="/clearpack.png" alt="Company Logo" className="login-page__logo-image" />
          </div>
          <h1 className="login-page__title">Welcome Back</h1>
          <p className="login-page__subtitle">
            Sign in to your account to continue
          </p>
        </div>

        <Card variant="elevated" className="login-page__card">
          <form onSubmit={handleSubmit} className="login-form">
            {error && (
              <div className="login-form__error-banner">
                {error}
              </div>
            )}

            <div className="login-form__field">
              <Input
                label="Username"
                type="text"
                name="username"
                placeholder="Enter your username"
                value={formData.username}
                onChange={handleInputChange('username')}
                required
              />
            </div>

            <div className="login-form__field">
              <Input
                label="Password"
                type="password"
                name="password"
                placeholder="Enter your password"
                value={formData.password}
                onChange={handleInputChange('password')}
                required
              />
            </div>

            <div className="login-form__actions">
              <Button
                type="submit"
                variant="primary"
                size="large"
                loading={isLoading}
                className="login-form__submit"
              >
                Sign In
              </Button>
            </div>
          </form>
        </Card>
      </div>
    </div>
  );
};

export default LoginPage; 